import * as Yup from 'yup';
export const initialEducationLevelValues = {
    description: '',
    enumId: '',
};
export const educationLevelSchema = Yup.object().shape({
    description: Yup.string(),
});
//# sourceMappingURL=education-level.js.map